import {
  FontWeight,
  Tag,
  TagColor,
  TagSize,
} from '@leland-dev/leland-ui-library';
import React from 'react';

import type { Scalars } from '../../__generated-gql-types__/globalTypes';
import LoadingIndicator from '../common/LoadingIndicator';

import CoachCategorySpecificInfo from './CoachCategorySpecificInfo';
import OtherCategoriesText from './OtherCategoriesText';
import ReviewSlider from './ReviewSlider';
import type { CoachQualificationsCoachFragment } from './__generated-gql-types__/CoachQualifications.generated';

interface CoachQualificationsProps {
  coach: CoachQualificationsCoachFragment;
  categoryId?: Scalars['CategoryUrn']['output'];
  viewAllReviews: () => void;
  hideReviews?: boolean;
  hideOtherCategories?: boolean;
}

const CoachQualifications: React.FC<CoachQualificationsProps> = ({
  coach,
  categoryId,
  viewAllReviews,
  hideReviews,
  hideOtherCategories,
}) => {
  const selectedCategory = coach.categoryInformationList?.find(
    (categoryInfo) => categoryInfo.category.id == categoryId,
  );

  return !selectedCategory ? (
    <div className="my-4 w-full text-center text-base">
      <LoadingIndicator iconClassName="w-7 h-7" />
    </div>
  ) : (
    <>
      <div key={selectedCategory?.category.id}>
        <h2 className="text-left text-2xl font-medium text-leland-gray-dark">
          {coach.user.firstName}&rsquo;s {selectedCategory.category.name}{' '}
          Qualifications
        </h2>
        <CoachCategorySpecificInfo
          coach={coach}
          categoryInfo={selectedCategory}
        />
        {selectedCategory.coachingFocusList &&
        selectedCategory.coachingFocusList.length > 0 ? (
          <div className="mt-6">
            <p className="mb-3 text-base font-normal text-leland-gray-light">
              {coach?.user?.firstName} can help with:
            </p>
            <div className="flex flex-wrap gap-2">
              {selectedCategory.coachingFocusList.map((coachingFocus) => (
                <Tag
                  key={coachingFocus.id}
                  text={coachingFocus.name}
                  fontWeight={FontWeight.NORMAL}
                  tagColor={TagColor.TRANSPARENT}
                  size={TagSize.LARGE}
                />
              ))}
            </div>
          </div>
        ) : null}
      </div>
      {hideReviews ? null : (
        <ReviewSlider
          className="mt-6"
          coach={coach}
          viewAllReviews={viewAllReviews}
          categoryUrn={selectedCategory.category.id}
        />
      )}
      {!hideOtherCategories ? (
        <OtherCategoriesText
          className="mt-6"
          coach={coach}
          excludeCategoryUrn={selectedCategory.category.id}
        />
      ) : null}
    </>
  );
};

export default CoachQualifications;
